// extracted by mini-css-extract-plugin
module.exports = {"icon":"xn_LQVj8"};